import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const initialValues = {
  categoryData: {},
  breadCrumbName: '',
  notifyProducts: [],
};

const useAppData = create(
  persist(
    (set) => ({
      ...initialValues,
      setCategoryTree: (categoryData) =>
        set(() => ({
          categoryData,
        })),

      setBreadCrumbName: (breadCrumbName) => set(() => ({ breadCrumbName })),
      setNotifyProducts: (sku, userId) =>
        set((state) => {
          return {
            ...state,
            notifyProducts: state.notifyProducts.concat({ sku, userId }),
          };
        }),

      clearAppData: () => set(() => initialValues),
    }),
    {
      name: 'app-data',
    }
  )
);

export default useAppData;
